/** 
* Newsletter
*
* @author Lubie
* @version 1.0
*/

(function($){
    $(document).on("click",".newsletter-submit",function(e){
        e.preventDefault();
        var email = $(".newsletter-email").val();
        console.log(email);
        newsletter_ajax(email);
    });
    
    /*$(document).on("click",".email-overlay",function(e){
       $(this).fadeOut();
       $("#input-infolettre").focus();
    });*/
    
    
    function newsletter_ajax(email){
    
         $.ajax({
            url: "/wp/wp-admin/admin-ajax.php",
             data: ({action : 'newsletter_ajax', email: email}),
             type: "post",
             success: function(data){
                 
                var json = jQuery.parseJSON(data);
                console.log(json.msg);
                
                //If succesful
                if((json.code == "1") || (json.code == "0")){
                        $(".newsletter-message").html("");
                        $(".newsletter-message").html(json.msg);
                        if(json.code == "1"){
                            $(".newsletter-email").val("");
                        }
                }
             },
             error: newsletterErrorHandler
         });
    }
    
    function newsletterErrorHandler(jqXHR, textStatus, errorThrown){
        console.log('mailchimp error');
    }
    })(jQuery);


// WEBPACK FOOTER //
// ./scripts/modules/newsletter.js